<template>
    <div >
            <el-card class="detail-card">
                <ul >
                   <li>
                       <p v-show="status=='服务台'&&canIEdit==true" ><el-button type="primary" @click="appointFn('发布工单接收')">发布工单接收</el-button></p>
                       <p v-show="status=='CAB审批'&&canIEdit==true"> <el-button type="primary"  @click="appointFn('CAB审批通过')">CAB审批通过</el-button></p>
                       <p  v-show="status=='CAB审批'&&canIEdit==true"><el-button type="primary" @click="appointFn('CAB审批不通过')">CAB审批不通过</el-button></p>
                       <p  v-show="status=='CAB审批'&&canIEdit==true"><el-button type="primary" @click="appointFn('全部通过')">CAB全部通过</el-button></p>
                       <p v-show="status=='制定发布方案'&&canIEdit==true"> <el-button type="primary"  @click="appointFn('制定发布方案')">制定发布方案</el-button></p>
                       <p v-show="status=='UAT环境实施发布'&&canIEdit==true"> <el-button type="primary"  @click="appointFn('实施通过')">UAT实施通过</el-button></p>
                       <p v-show="status=='UAT环境实施发布'&&canIEdit==true"><el-button type="primary"  @click="appointFn('实施不通过')">UAT实施不通过</el-button></p>
                       <p v-show="status=='生产环境实施发布'&&canIEdit==true" ><el-button type="primary" @click="appointFn('发布')">发布完成</el-button></p>
                       <p v-show="status=='生产环境实施发布'&&canIEdit==true"> <el-button type="primary"  @click="appointFn('发布失败')">发布失败</el-button></p>
                       <p v-show="status=='观察中'&&canIEdit==true"><el-button type="primary"  @click="appointFn('观察完成')">观察完成</el-button></p>
                       <p v-show="status=='服务台'&&recoverEdit==true"><el-button type="primary" @click="recallEvent('撤回')">撤回</el-button></p>
                       <p v-show="status !='发布完成'&&status!='拒绝'&&status!='取消'&&status!='发布失败'&&status!='创建'&&canIEdit==true"><el-button type="primary"  @click="appointFn('驳回')">驳回</el-button></p>
                       <p v-show="status=='创建'&&canIEdit==true"><el-button type="primary"  @click="deliver('提交')">提交</el-button></p>
                       <p v-show="status !='发布完成'&&status!='拒绝'&&status!='取消'&&status!='发布失败'&&status!='服务台'&&canIEdit==true"><el-button type="primary" @click="appointFn('转交')" v-w-role="'ITSM-0253'">转交</el-button></p>
                       <!--拒绝-->
                       <p v-show="status!='发布完成'&&status!='拒绝'&&status!='取消'&&status!='发布失败'&&status!='创建'&&canIEdit==true"> <el-button type="primary" @click="appointFn('拒绝')" >拒绝</el-button></p>
                       <!--取消-->
                       <p v-show="canCancel&&status!='发布完成'&&status!='取消'&&status!='拒绝'&&status!='发布失败'&&status!='创建'&&canIEdit==true"> <el-button type="primary"  @click="appointFn('取消') ">取消</el-button></p>
                       <!--编辑-->
                       <p v-show="status!='发布完成'&&status!='取消'&&status!='拒绝'&&status!='发布失败'&&canIEdit==true"><el-button type="primary" @click="toDeployUpdate">编辑</el-button></p>
                       <router-link :to="{ path: '/flowChart',query:{ serialNumber:serialNumber}}">
                           <el-button type="primary">流程跟踪</el-button>
                       </router-link>
                   </li>
                   <li>
                       <el-row>
                           <router-link  :to="{ path:'/eventAdd',query: { parentNumber:serialNumber,callback:getDetail } }">
                           <el-button type="primary" v-w-role="'ITSM-0226'">提交为事件</el-button>
                           </router-link>
                           <router-link  :to="{ path:'/problemAdd',query: { parentNumber:serialNumber,callback:getDetail } }">
                           <el-button type="primary" v-w-role="'ITSM-0227'">提交为问题</el-button>
                           </router-link>
                           <router-link  :to="{ path:'/changeAdd',query: { parentNumber:serialNumber,callback:getDetail } }">
                           <el-button type="primary" v-w-role="'ITSM-0228'">提交为变更</el-button>
                           </router-link>
                           <router-link  :to="{ path:'/deployAdd',query: { parentNumber:serialNumber,callback:getDetail } }">
                           <el-button type="primary" v-w-role="'ITSM-0229'">提交为发布</el-button>
                           </router-link>

                           <router-link  :to="{ path:'/serveCatalogUpdata',query: { parentNumber:serialNumber,callback:getDetail } }">
                           <el-button type="primary" v-w-role="'ITSM-0230'">提交为服务</el-button>
                           </router-link>
                       </el-row>
                   </li>

                </ul>
                <el-row>
                    <el-col :span="7"><label>编号：</label>{{ detail.serialNumber }}--{{status}}</el-col>
                    <el-col :span="17"><label>标题：</label>{{ detail.title }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="7"><label>请求人：</label>{{ detail.requester&&detail.requester.name }}</el-col>
                    <el-col :span="17"><label>创建时间：</label>{{ detail.createTime }}</el-col>
                </el-row>
            </el-card>
            <div class="tab-card">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane :label="item.name" :name="item.index" v-for="item in tabViews" :key="item.index">
                        <div v-loading="loading" v-if="loading" style="width:100%;height:300px;"></div>
                        <keep-alive v-if="!loading">
                            <component :is="currentView"
                                       :detail="detail"
                                       :status="status"
                                       :serialNumber="serialNumber"
                                       :callback="getDetail"
                                       :companyList="companyList"
                                       :eventList="eventList"
                                       :problemList="problemList"
                                       :changeList="changeList"
                                       :deployList="deployList"
                                       :dataBaseList="dataBaseList"
                                       :hotFAQ="hotFAQ"
                            ></component>
                        </keep-alive>
                    </el-tab-pane>
                </el-tabs>
            </div>
    </div>
</template>

<script>
    import commonService from "../../services/common.service"
    import services from "./deploy.service";
    import detailForm from "./detailComponents/detailForm.vue";                     //表单明细
    import detailHandle from "./detailComponents/detailHandle.vue";
    import ueditor from "../../components/ueditor.vue"
    import WorkHours from "../common/detail/detailWorkHours.vue";                  // 工时/成本
    import SolveProject from "../common/detail/detailSolveProject.vue";            // 解决方案
    import HistoricRecords from "../common/detail/detailHistoricRecords.vue";      // 历史记录
    import HistoricNews from "../common/detail/detailHistoricNews.vue";            // 历史消息
    import detailKnowledge from "../common/detail/detailKnowledge.vue";            // 推荐知识
    import RelevancyEvent from "../common/detail/detailRelevancyEvent.vue";        // 关联事件
    import RelevancyQue from "../common/detail/detailRelevancyQue.vue";            // 关联问题
    import RelevancyChange from "../common/detail/detailRelevancyChange.vue";      //关联变更
    import RelevancyIssue from "../common/detail/detailRelevancyIssue.vue";        // 关联发布
    import RelevancyConfig from "../common/detail/detailRelevancyConfig.vue";      // 关联配置项
    import RelevancyService from "../common/detail/detailRelevancyService.vue";    // 关联服务
    export default {
        components:{
            detailForm,
            detailHandle,
            WorkHours,
            SolveProject,
            HistoricRecords,
            HistoricNews,
            detailKnowledge,
            RelevancyEvent,
            RelevancyQue,
            RelevancyChange,
            ueditor,
            RelevancyIssue,
            RelevancyConfig,
            RelevancyService
        },

        data() {
            return {
                detail:{},
                companyList:[],
                eventList:[],
                problemList:[],
                changeList:[],
                deployList:[],
                dataBaseList:[],
                status:"",   // 状态
                index:0,
                loading:true,
                activeName:"detailForm",
                hotFAQ:[],
                tabViews:[
                    { name:"表单明细",index:"detailForm"},
                    { name:"处理明细",index:"detailHandle"},
                    { name:"工时",index:"WorkHours"},      //
                    { name:"解决方案",index:"SolveProject"},  //
                    { name:"历史记录",index:"HistoricRecords"},  //
                    { name:"历史消息",index:"HistoricNews"}, //
                    { name:"推荐知识",index:"detailKnowledge"},//
                    { name:"关联事件",index:"RelevancyEvent"},//
                    { name:"关联问题",index:"RelevancyQue"},//
                    { name:"关联变更",index:"RelevancyChange"},//
                    { name:"关联发布",index:"RelevancyIssue"},//
                    { name:"关联配置项",index:"RelevancyConfig"},//
                    { name:"关联服务",index:"RelevancyService"},//

                ],
                canCancel:false,
                canIEdit: false,
                recoverEdit:false,
            }
        },

        computed:{
            currentView(){
                return this.tabViews[this.index].index;
            },
            query:function () {
                return this.$route.query
            },
            serialNumber:function () {
                return this.query.serialNumber
            },
            dictionary(){
                return this.$store.state.dictionary;
            },
            deployStatus(){
                return this.dictionary.deploy_status;
            },
            // 事件分类id
            eventType(){
                return this.$store.state.caseType.event;
            },
            // 问题分类id
            problemType(){
                return this.$store.state.caseType.problem;
            },
            // 变更分类id
            changeType(){
                return this.$store.state.caseType.change;
            },
            // 发布分类id
            deployType(){
                return this.$store.state.caseType.deploy;
            },
            designator(){
                return window.localStorage.getItem('internalUserid')
            },
            user(){
                return window.localStorage.getItem('name')
            },
            //登陆的用户角色类型:超管、服务台组、普通用户
            userRole(){
                return window.localStorage.getItem('userRole')
            },

        },
        created() {
            if (this.$route.query){
                // console.log(this.$route.query);
                this.sn = this.$route.query.serialNumber
            }
            this.getDetail();
            this.getCompanyList();
            this.getEventList();
            this.getProblemList();
            this.getChangeList();
            this.getDeployList();
            this.getDataBaseList()

        },
        watch:{
            '$route'(to,from){
                if (to.query.serialNumber != from.query.serialNumber){
                    this.sn = to.query.serialNumber
                    this.getDetail()
                }
            }
        },
        methods: {
            getDetail(){
                if (this.userRole=='super'){
                    this.canIEdit=true
                    this.recoverEdit = true
                }else{
                    this.canIEdit=false
                    this.recoverEdit = false
                }
                services.detail({serialNumber:this.serialNumber}).then(res => {
                    // console.log(res);
                    this.detail =  res;
                    //database返回的是字符串13，转换成数字13可以兑换出数据
                    this.detail.database=+this.detail.database
                    res.currentHandler==this.user?this.canIEdit=true:''
                    res.requester.name&&res.requester.name == this.user?this.recoverEdit=true:''
                    // console.log(res)
                    // console.log(this.detail.database,'database');
                    // console.log(this.deployStatus);
                    this.status=this.getNameById(res.status,this.deployStatus)
                    if (this.status=='服务台'&&this.userRole=='reception'){
                        this.canIEdit=true
                    }
                    if (this.status=='服务台'&& res.requester.name == this.user){
                        this.recoverEdit=true
                    }
                    if (this.status=='创建'&& res.requester.name == this.user){
                        this.canIEdit=true
                    }
                    this.search();
                    //判断取消按钮是否能出现
                    this.canICancel()
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(()=>{
                    this.loading=false
                })
            },
            //判断取消按钮是否能出现
            canICancel(){
                // s('lalla');
                let username =window.localStorage.getItem('name')
                let createUser=this.detail.createUser
                let requester=this.detail.requester
                // console.log(username,'username');
                // console.log(createUser,'createUser');
                // console.log(requester,'requester');
                if (username==createUser){
                    // console.log('hahah');
                    this.canCancel=true
                }
            },
            // 获取所属公司列表
            getCompanyList(){
                commonService.companyList().then(res => {
                    this.companyList = res.list;
                })
            },
            // 获取事件分类
            getEventList(){
                commonService.categoryList(this.eventType.id).then(res => {
                    this.eventList = res;
                })
            },
            // 获取问题分类
            getProblemList(){
                commonService.categoryList(this.problemType.id).then(res => {
                    this.problemList = res;
                })
            },
            // 获取变更分类
            getChangeList(){
                commonService.categoryList(this.changeType.id).then(res => {
                    this.changeList = res;
                })
            },
            // 获取发布分类
            getDeployList(){
                commonService.categoryList(this.deployType.id).then(res => {
                    this.deployList = res;
                })
            },
            getDataBaseList(){
                commonService.dataBase().then(res => {
                    // console.log(res);
                    this.dataBaseList = res;
                })

            },
            search(){//默认查询
                services.getKnowledgeList({"Query":this.detail.title,"pageIndex":1,"pageSize":5}).then(res=>{
                    this.hotFAQ = res.KnowledgeTable;
                })
            },
            // 发布流程操作
            appointFn(val){
                this.$router.push({
                    path: '/deployAppoint',
                    name: "deployAppoint",
                    query: {
                        type:val,
                        serialNumber:this.serialNumber,
                        callback:this.getDetail,
                        deployType:this.detail.deployType,
                        status:this.status,
                        currentHandler:this.detail.currentHandler
                    }
                })
            },
            // 撤回
            recallEvent(val){
                this.$confirm('您确定要撤回吗?', '撤回', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    let params = {
                        serialNumber:this.serialNumber,
                        handle: val
                    }
                    commonService.deployHandle(params).then(res => {
                        this.$message({
                            type: 'success',
                            message: '撤回成功!'
                        });
                        this.getDetail()
                    }).catch(err => {
                        this.isSubmit=false
                        this.$message.error(err.message);
                    })

                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消撤回'
                  });
                });
            },
            toDeployUpdate(){
                this.$router.push({
                    path: '/deployAdd',
                    name: "deployAdd",
                    query: {
                        type:'edit',
                        serialNumber:this.serialNumber,
                        callback:this.getDetail
                    }
                })
            },
            backOff(){
                this.$router.back();
            },
            deliver(text){
                this.openMessage('您确定要提交到服务台吗？', '确定', () => {
                    commonService.deployHandle({ handle:text,serialNumber:this.serialNumber,designator:this.designator }).then(res => {
                        this.$message.success("提交成功");
                        this.getDetail();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                });
            },
            //处理完成
            openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText,
                    confirmButtonClass: 'confirmBtn'
                }).then(() => {
                    doit();
                })
            },
            handleClick(tab, event){
                this.index = tab.index;
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    .zebra-item{
        span{
            padding-right: 10px;
        }
    }
    .el-button--mini{
        margin: 0 10px;
    }
</style>
